import React from 'react';

const AgricultureSoftwareDevServices = () => {
    return (
        <div className="section-py">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-10 gap-4 grid">
                        <h2 className="mb-0">Agriculture Software Development Services We Offer</h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 mb-10">
                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-farm-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                Agriculture Farm Management Software
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Plan, monitor, and analyze all your farming activities—crop cycles, machinery use, weather
                                insights—on a unified platform. This Farm Management Software Solution forms the backbone of
                                modern agriculture custom software development.
                            </p>
                        </div>
                    </div>

                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-livestock-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                Livestock Management Software
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Track livestock health, reproduction, feeding schedules, and movement with automated alerts and
                                detailed reporting. Our Cattle Management Software is part of our broader suite of Custom
                                Agriculture Software Solutions tailored for operational efficiency.
                            </p>
                        </div>
                    </div>
                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-smart-farm-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                Smart Farming Software Development
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Leverage IoT, sensors, and automation to optimize resource use, reduce waste, and make data-driven
                                decisions in real time. As a Top Agriculture Software Development Company, we deliver Smart
                                Agriculture Solutions that scale with your farm.
                            </p>
                        </div>
                    </div>
                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-farm-accounting-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                Farm Accounting Software
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Manage farm finances with ease—track expenses, generate invoices, calculate ROI, and monitor
                                profitability season by season.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2">
                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-aquaculture-software-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                Aquaculture Software Development
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Monitor aquatic environments, automate feeding schedules, and manage fish health across ponds and
                                hatcheries efficiently.
                            </p>
                        </div>
                    </div>

                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-custom-farm-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                Custom Agriculture Drone Software Development
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Enable aerial monitoring, automated crop scanning, and targeted pesticide application through
                                drone-based solutions. These are part of our Agricultural App Development offerings with drone and
                                sensor integrations.
                            </p>
                        </div>
                    </div>
                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-ai-solution-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                AI Solutions For Precision Agriculture
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Use machine learning models to detect crop stress, predict yields, and recommend timely
                                interventions with pinpoint accuracy. These AI Solutions for Agriculture empower smarter,
                                predictive farming.
                            </p>
                        </div>
                    </div>
                    <div className="card rounded-10 border hover:border-[#00B050]">
                        <div className="bg-intelligent-farm-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                Intelligent Chemical Spraying Systems
                            </p>
                        </div>
                        <div className="p-5">
                            <p className="text-secondary mb-0 fs-md">
                                Build smart systems that apply the right amount of chemical at the right place—minimizing costs
                                and environmental impact. Our Agriculture IT Solutions ensure compliance, accuracy, and
                                field-ready automation.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AgricultureSoftwareDevServices;
